import {all} from 'redux-saga/effects';

import {createFetchSagaLatest} from 'utils/sagas';

import * as actions from './';
import * as sdk from 'sdk/locations';

function* locationDetailSaga() {
  yield all([createFetchSagaLatest(actions.fetchLocation, sdk.fetchLocation)]);
}

export default locationDetailSaga;
